import { SolidStar } from 'src/components/ui/Stars/StarIcon'

type SelectedFacet = {
  key: string
  value: string
}

interface ProductWellRatedFlagProps {
  selectedFacets?: SelectedFacet[]
  className?: string
}

function isHighRatedFacetSelected(selectedFacets: SelectedFacet[]) {
  const ratingFacets = selectedFacets.filter((facet) => {
    const normalizedKey = facet.key
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

    return (
      normalizedKey?.includes('avaliac') ||
      normalizedKey?.includes('rating') ||
      normalizedKey?.includes('review')
    )
  })

  if (ratingFacets.length === 0) {
    return false
  }

  let hasHighRatingSelected = false

  for (const facet of ratingFacets) {
    const facetValue = String(facet.value ?? '').trim()
    const facetValueAsNumber = Number(facetValue)

    if (!Number.isNaN(facetValueAsNumber)) {
      if (facetValueAsNumber !== 4 && facetValueAsNumber !== 5) {
        return false
      }

      hasHighRatingSelected = true
      continue
    }

    const ratingValues = facetValue.match(/\b[1-5]\b/g)

    if (!ratingValues || ratingValues.length === 0) {
      return false
    }

    const hasAnyNonHighRating = ratingValues.some(
      (value) => Number(value) !== 4 && Number(value) !== 5
    )

    if (hasAnyNonHighRating) {
      return false
    }

    hasHighRatingSelected = true
  }

  return hasHighRatingSelected
}

export default function ProductWellRatedFlag({
  selectedFacets = [],
  className = '',
}: Readonly<ProductWellRatedFlagProps>) {
  if (!isHighRatedFacetSelected(selectedFacets)) {
    return null
  }

  return (
    <p
      className={`hidden font-inter text-primaryBlue text-[9px] md:text-[10px] font-bold leading-4 my-1 items-center uppercase gap-1 ${className}`}
      data-dy-id="product-well-rated-flag"
    >
      <SolidStar width={16} height={16} className="text-primaryBlue" />
      Produto bem avaliado
    </p>
  )
}
